import { GetVehicleType } from "../../Services";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import { useState, useEffect } from "react";
import AddVehicle from "../../forms/vehicle/AddVehicleType";
import axios from "axios";
import { toast } from "react-toastify";

const VehicleType = () => {
  const navigate = useNavigate();

  // State variables
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingVehicleType, setEditingVehicleType] = useState(null);

  // Fetch vehicle types
  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        // const res = await axios.get(
        //   "https://binberu.idaprocharity.com/api/v1/admin/get-vehicle-type"
        // );

        const res = await GetVehicleType.fetchVehicleType();
        const data = Array.isArray(res.data) ? res.data : res.data.data || [];
        // console.log("Vehicle types:", data);
        setVehicleTypes(data);
      } catch (error) {
        console.error("Error fetching vehicle types:", error);
        toast.error("Failed to fetch vehicle types", {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchVehicleTypes();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle edit button click
  const handleEdit = (vehicleType) => {
    setEditingVehicleType(vehicleType);
    setShowModal(true);
  };

  // Handle delete button click
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this vehicle type?"))
      return;

    try {
      await axios.delete(
        `https://binberu.idaprocharity.com/api/v1/admin/vehicle-types/${id}`,
      );
      setVehicleTypes((prev) => prev.filter((vt) => vt.id !== id));
      toast.success("Vehicle type deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error deleting vehicle type:", error);
      toast.error(
        error.response?.data?.message || "Failed to delete vehicle type",
        {
          position: "top-right",
          autoClose: 3000,
        },
      );
    }
  };

  // Function to handle adding a new vehicle type
  const handleVehicleAdded = (newVehicleType) => {
    setVehicleTypes((prev) => [...prev, newVehicleType]); // Update the state with the new vehicle type
    setShowModal(false); // Close the modal after adding
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Vehicle Types</h2>
        </div>
        <div className="card">
          <div className="card-header flex items-center justify-between">
            <button
              type="button"
              onClick={() => {
                setEditingVehicleType(null);
                setShowModal(true);
              }}
              className="btn btn-primary btn-sm flex items-center"
            >
              <i className="fa fa-car mr-1"></i>
              Add Vehicle Type
            </button>
          </div>
          <Modal showModal={showModal} setShowModal={setShowModal}>
            <AddVehicle
              editingVehicleType={editingVehicleType}
              setEditingVehicleType={setEditingVehicleType}
              onVehicleAdded={handleVehicleAdded} // Pass the function to handle new vehicle addition
            />
          </Modal>
          <div className="card-body flex flex-col gap-4">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-4">
                <button type="button" className="btn btn-outline-secondary">
                  CSV
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  Excel
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  PDF
                </button>
              </div>

              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                style={{ width: "300px" }}
              />
            </div>

            <div className="mt-4">
              {loading ? (
                <p>Loading vehicle types...</p>
              ) : (
                <table className="table table-bordered w-full">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Passenger Capacity</th>
                      <th>Cargo Capacity</th>
                      <th>Fuel Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleTypes.length > 0 ? (
                      vehicleTypes.map((vehicleType) => (
                        <tr key={vehicleType.id}>
                          <td>{vehicleType.id}</td>
                          <td>{vehicleType.name}</td>
                          <td>{vehicleType.description || "-"}</td>
                          <td>{vehicleType.passenger_capacity || "-"}</td>
                          <td>{vehicleType.cargo_capacity || "-"}</td>
                          <td>{vehicleType.fuel_type}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => handleEdit(vehicleType)}
                              data-bs-toggle="tooltip"
                              title="Edit"
                              aria-label="Edit vehicle type"
                            >
                              <i className="fas fa-edit" />
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger ml-2"
                              onClick={() => handleDelete(vehicleType.id)}
                              data-bs-toggle="tooltip"
                              title="Delete"
                              aria-label="Delete vehicle type"
                            >
                              <i className="fas fa-trash" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No vehicle types found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) handlePageChange(currentPage - 1);
                  }}
                >
                  &laquo;
                </a>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  className={`page-item ${
                    currentPage === page + 1 ? "active" : ""
                  }`}
                  key={page + 1}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(page + 1);
                    }}
                  >
                    {page + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      handlePageChange(currentPage + 1);
                  }}
                >
                  &raquo;
                </a>
              </li>
            </ul>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default VehicleType;
